export const SET_DATA = 'blog/SET_DATA';
export const SET_CATEGORY = 'blog/SET_CATEGORY';
export const SET_BLOG = 'blog/SET_BLOG';
